import { JSONSchemaType } from 'ajv'

export interface IRecipeFormData {
  recipeName: string
  defaultParams: string
  connectors: string
  workflow: string
  isInactive: boolean
}

const RecipeSchema: JSONSchemaType<IRecipeFormData> = {
  type: 'object',
  properties: {
    recipeName: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    defaultParams: {
      type: 'string',
    },
    connectors: {
      type: 'string',
    },
    workflow: {
      type: 'string',
    },
    isInactive: {
      type: 'boolean',
      default: false,
    },
  },
  required: ['recipeName'],
  additionalProperties: false,
}

export default RecipeSchema
